export const getAnonymousId = () => {
  const anonymousId = localStorage.getItem('ajs_anonymous_id');
  return anonymousId;
};
